// --------------------------------------------------------------------------
// Edit profile template
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {

        var $editButton = context.find('.edit-button');
        var $inputEnableEdit = $('input[name="EnableEdit"]');
        var $form = $inputEnableEdit.closest('form');
        var editEnabled = $inputEnableEdit.val() == 'True';
        var $gdprPhonePref = $form.find('[name="ContactPreferences.ContactByPhoneOptIn"]');
        var $gdprTextPref = $form.find('[name="ContactPreferences.ContactByTextOptIn"]');
        var $phoneInput = $form.find('[name="ContactDetails.HomePhone"]');
        var $mobileInput = $form.find('[name="ContactDetails.MobilePhone"]');
        var visibleClass = 'visible';
        var hiddenClass = 'hidden';

        if (!editEnabled) {
            // find the form and its jQuery.validate object and ignore
            // validation for contact preference boxes if we are not in edit mode
            $form.validate().settings.ignore += ',[data-name="contact-preference"]';

            // disable channel's inputs so that clicking on "Yes", "No" doesn't change their state
            $form.find('[data-name="contact-preference"]').attr('disabled', 'disabled');
            $form.find('[data-name="gdpr-wrapper"]').addClass('gdpr-preferences--disabled');
        }

        function showEditableContent(button) {
            button.prev().addClass(hiddenClass);
            button.next('.editable').addClass(visibleClass);
            button.addClass(hiddenClass);
        }

        //Add click event on edit button
        $editButton.on('click', function (e) {
            e.preventDefault();
            showEditableContent($(this));
        });

        //Add accessible display
        $editButton.on({
            focus: function focus() {
                showEditableContent($(this));
            }
        });

        // Make the phone and text inputs required depending on the GDPR pref current value
        function makeInputRequired($prefInput, $formInput, $mobileInput) {
            return function (e) {
                var required = $prefInput.filter(':checked').val() === 'True';

                if (required) {
                    if ($mobileInput) {
                        // If a $mobileInput argument is specified, then it is a phone channel's
                        // handler and we should look up for mobile's field input and do NOT require
                        // a home phone number if a mobile one has been already provided
                        $formInput.rules('add', {
                            required: function required(element) {
                                return !$mobileInput.is(':filled');
                            }
                        });
                    } else {
                        // This is text GDPR pref, make the mobile required
                        $formInput.rules('add', { required: true });
                    }
                } else {
                    $formInput.rules('remove', 'required');
                }
            };
        }

        // Enable dynamic validation for phone and text GDPR channels        
        $gdprPhonePref.on('change', makeInputRequired($gdprPhonePref, $phoneInput, $mobileInput));
        $gdprTextPref.on('change', makeInputRequired($gdprTextPref, $mobileInput));

        // On the page load set the correct required rules for the phone and text inputs
        // Defer the call to the next JS Event Loop so that jQuery validate library is initialised
        setTimeout(function () {
            $gdprPhonePref.trigger('change');
            $gdprTextPref.trigger('change');
        }, 0);
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/profile/profile-edit.js
// module id = 251
// module chunks = 0